import { render, staticRenderFns } from "./DecimalCell.vue?vue&type=template&id=3ae42340&"
import script from "./DecimalCell.vue?vue&type=script&lang=js&"
export * from "./DecimalCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports